import { isEmpty, isNull } from 'lodash';
import { useInfiniteQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';

const DEFAULT_PAGE = 30;

export default function useExploreTradingPhotoCardsQueryV2({
  artistId,
  memberIds,
  eventIds,
  category,
  userProfileId,
  onlyIdentityVerified,
  photoCardCategories,
  sortBy = 'scoring',
  perPage = DEFAULT_PAGE,
  photoCardId
}) {
  async function fetchExploreTradingPhotoCards({ pageParam = 1 }) {
    const queryParams = new URLSearchParams({
      per_page: perPage,
      page: pageParam,
      sort_by: sortBy
    });

    if (!isEmpty(memberIds)) {
      queryParams.append('member_ids', memberIds);
    }

    if (!isEmpty(eventIds)) {
      queryParams.append('event_ids', eventIds);
    }

    if (!isEmpty(photoCardId)) {
      queryParams.append('photo_card_id', photoCardId);
    }

    if (onlyIdentityVerified) {
      queryParams.append('identified', onlyIdentityVerified);
    }

    if (userProfileId) {
      queryParams.append('user_profile_id', userProfileId);
    }

    if (category) {
      queryParams.append('category', category);
    }

    if (!isEmpty(photoCardCategories)) {
      queryParams.append('photo_card_categories', photoCardCategories);
    }

    const url = `/api/v1/artists/${artistId}/explore_trading_photo_cards?${queryParams.toString()}`;
    try {
      const data = await queryGet(url);
      return data;
    } catch (_error) {
      throw new Error('Error fetching paginated data.');
    }
  }

  const { data, isFetching, fetchNextPage, hasNextPage } = useInfiniteQuery(
    [
      'ExploreTradingPhotoCardsV2',
      artistId,
      memberIds,
      eventIds,
      category,
      userProfileId,
      onlyIdentityVerified,
      photoCardId,
      photoCardCategories,
      sortBy
    ],
    fetchExploreTradingPhotoCards,
    {
      enabled: !!artistId && !isNull(memberIds),
      getNextPageParam: (lastPage) => {
        if (lastPage?.meta?.pagination?.nextPage) {
          return lastPage?.meta?.pagination?.nextPage;
        }
        return undefined;
      }
    }
  );

  return {
    data,
    isFetching,
    fetchNextPage,
    hasNextPage
  };
}
